module.exports = __webpack_public_path__ + "static/media/accenture_log3.50f5124f.png";